import type { BlockExportMapping } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { PlanCardBlock } from "./PlanCard";
import { PricingBlock1 } from "./PricingBlock1";

export const pricingBlocks: BlockExportMapping = {
  PricingBlock1,
  PlanCardBlock,
};
